<template>
    <div class="payout-on-container">
        <template v-if="payOnMonth.length == 12">
            <v-chip small>Every Month</v-chip>
        </template>
        <div v-else>
            <template v-if="payOnMonth.length <= 2">
                <v-chip v-for="(item, index) in payOnMonth" :key="index" small>
                    {{$moment().month(item - 1).format(monthFormat)}}
                </v-chip>
            </template>
            <template v-else>
                <v-chip v-for="(item, index) in payOnMonth.slice(0, 2)" :key="index" small>
                    {{$moment().month(item - 1).format(monthFormat)}}
                </v-chip>
                <v-chip small :title="payOnMonth
                                        .slice(2)
                                        .map(m => $moment().month(m - 1).format(monthFormat)) 
                                        .join(', ')">
                    +{{ payOnMonth.length - 2 }} month<span v-if="(payOnMonth.length-2)>1">s</span>
                </v-chip>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: ['payOnMonth','shortenMonths'],
    computed: {
        monthFormat() {
            return this.shortenMonths ? "MMM" : "MMMM"
        }
    }
}
</script>
<style scoped>
.payout-on-container {
    margin-left:-5px;
}
</style>